// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ybGE62MUFEjXGxoguKFx{width:532px;min-width:492px;max-width:100%}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/pages/international/ui/BusinessAddress/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,eAAA,CACA,cAAA","sourcesContent":[".wrap {\n  width: 532px;\n  min-width: 492px;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ybGE62MUFEjXGxoguKFx`
};
export default ___CSS_LOADER_EXPORT___;
